module.exports = __webpack_public_path__ + "static/media/continental@2x.710dc4f4.png";